import styled from '@emotion/styled'

const Content = styled.span`
  p {
    margin: 0;
  }

  .ql-align-center {
    text-align: center;
  }
  .ql-align-right {
    text-align: right;
  }
  .ql-align-justify {
    text-align: justify;
  }

  img {
    max-width: 100%;
  }
`

const ArticleContent = styled(Content)`
  p {
    font-size: 18px;
    letter-spacing: 0.02rem;
    line-height: 2rem;
  }

  img {
    margin: 18px 0;
  }
`

const HTMLContent = ({ content, type }) => {
  if (!content) {
    return null
  }

  return type === 'article' ? (
    <ArticleContent dangerouslySetInnerHTML={{ __html: content }} />
  ) : (
    <Content dangerouslySetInnerHTML={{ __html: content }} />
  )
}

export default HTMLContent
